(function () {
  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-ae-step]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-ae-panel]"));
    var range = root.querySelector("[data-ae-range]");
    var total = steps.length;
    if (!total) return;

    var index = 0;

    function go(nextIndex) {
      index = Math.max(0, Math.min(total - 1, nextIndex));
      steps.forEach(function (step, i) {
        var on = i === index;
        step.classList.toggle("is-active", on);
        step.setAttribute("aria-current", on ? "true" : "false");
      });
      panels.forEach(function (panel) {
        panel.hidden = Number(panel.getAttribute("data-ae-panel")) !== index;
      });
      if (range) range.value = String(index);
    }

    function snapFromRange() {
      var max = Number(range.max) || total - 1;
      var raw = Number(range.value) || 0;
      var snapped = Math.round((raw / max) * (total - 1));
      go(snapped);
    }

    steps.forEach(function (step, i) {
      step.addEventListener("click", function () {
        go(i);
      });
    });

    if (range) {
      range.min = "0";
      range.max = String(Math.max(total - 1, 1));
      range.step = "1";
      range.addEventListener("input", snapFromRange);
      range.addEventListener("change", snapFromRange);
    }

    go(0);
  }

  document.querySelectorAll("[data-ae-drag]").forEach(init);
})();
